import { render } from "./MWalletWithdrawal.vue?vue&type=template&id=7316dc7d&scoped=true"
import script from "./MWalletWithdrawal.vue?vue&type=script&lang=js"
export * from "./MWalletWithdrawal.vue?vue&type=script&lang=js"

import "./MWalletWithdrawal.vue?vue&type=style&index=0&id=7316dc7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7316dc7d"]])

export default __exports__